import React, { ComponentType } from 'react';
import dynamic from 'next/dynamic';
import { LandingPageConfig } from 'src/generated/landing-page-config-schemas/v1/type';

type Props = {
  slice: LandingPageConfig['data']['slices'][number];
  backgroundColor?: string;
};

// next/dynamic (React.lazy + Suspense composite) server-renders these in the
// Pages Router, so slices arrive in the initial HTML instead of popping in on
// the client and shifting layout as each chunk loads.
const sliceComponents: Record<string, ComponentType<any>> = {
  about: dynamic(() => import('./v1/slices/About')),
  'call-to-action-banner': dynamic(
    () => import('./v1/slices/CallToActionBanner'),
  ),
  'frequently-asked-questions': dynamic(
    () => import('./v1/slices/FrequentlyAskedQuestions'),
  ),
  hero: dynamic(() => import('./v1/slices/Hero')),
  'highlighted-meals': dynamic(() => import('./v1/slices/HighlightedMeals')),
  'how-it-works': dynamic(() => import('./v1/slices/HowItWorks')),
  testimonials: dynamic(() => import('./v1/slices/Testimonials')),
  'value-proposition': dynamic(() => import('./v1/slices/ValueProposition')),
  plans: dynamic(() => import('./v1/slices/Plans')),
};

const SliceRenderer: React.FC<Props> = ({ slice, backgroundColor }) => {
  const SliceComponent = sliceComponents[slice.type];

  if (!SliceComponent) {
    return null;
  }

  return <SliceComponent {...slice} backgroundColor={backgroundColor} />;
};

export default SliceRenderer;
